require('./memo-edit.jade')

class MemoCtrl
  constructor: (@$scope, @$modal, @PaymentService) ->
    @memo = @$scope.$parent.roundInfo.memo

  editMemo: (paid)->
    if paid
      @$modal.open
        size: 'lg'
        templateUrl: 'round-detail/score-card-memo/memo-edit.jade'
        controller: 'MemoModalCtrl'
        resolve:
          modalModel: =>
            memo: @memo
            id: @$scope.$parent.roundInfo.id
      .result.then (memo) =>
        @memo = memo
    else
      @PaymentService.payModal()


MemoCtrl.$inject = [
  '$scope'
  '$modal'
  'PaymentService'
]

module.exports = MemoCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/score-card-memo/memo-controller.coffee